/**
 * The few paths the app answers to, read off the address bar.
 *
 * There is no router library: the app has few enough screens that the browser
 * history is enough of one. What is worth keeping in a module of its own is
 * the parsing — a path is untrusted text typed by whoever is visiting, and
 * getting a code out of it is the only part with a rule to get wrong.
 */

export const REGISTER_PATH = '/register';
export const VERIFY_EMAIL_PATH = '/verify-email';
export const LOGIN_PATH = '/login';

/** Screens a signed-in visitor has nothing left to see. */
export const AUTH_PATHS: ReadonlySet<string> = new Set([LOGIN_PATH, REGISTER_PATH]);

const INVITE_PREFIX = '/invite/';

/**
 * The invite code in `/invite/<code>`, or `null` when the path is not one.
 *
 * A trailing slash, an empty code and a path that merely starts with the word
 * all answer `null`: an invite screen with no code has nothing to show, and
 * sending an empty code to the API would only turn a typo into a refusal.
 */
export function readInviteCode(path: string): string | null {
  if (!path.startsWith(INVITE_PREFIX)) {
    return null;
  }

  const raw = path.slice(INVITE_PREFIX.length);
  if (raw === '' || raw.includes('/')) {
    return null;
  }

  const code = decodeURIComponent(raw).trim();
  return code === '' ? null : code;
}
